
const loginSuccess = mobileNo => {
  if (window.android && window.android.loginSuccess) {
    console.log(window.android.loginSuccess, '桥接对象')
    console.log(mobileNo, '电话')
    window.android.loginSuccess(mobileNo)
  }
}

const loginOut = () => {
  if (window.android && window.android.loginOut) {
    window.android.loginOut()
  }
}

const formatImgSmaller = url => {
  if(url && url.indexOf('?') >= 0){
    return (url && url + '&x-oss-process=style/smaller') || '';
  }else{
    return (url && url + '?x-oss-process=style/smaller') || '';
  }
};

var formatImgLittleq = url => {
  if(url && url.indexOf('?') >= 0){
    return (url && url + '&x-oss-process=style/littleq') || '';
  }else{
    return (url && url + '?x-oss-process=style/littleq') || '';
  }
  
};

var loadingImgError = e => {
  const t = e.target
  t.src = require('@/assets/images/common/user-default-thumb.png')
  
};

export default {
  loginSuccess,
  loginOut,
  formatImgSmaller,
  formatImgLittleq,
  loadingImgError
}
